import React from 'react';
import { bool, func, node, number, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import SelectedPills from './SelectedPills';

import css from './MainPanelHeader.module.css';

/**
 * The desktop results toolbar — one line (P25009-491 BR-5):
 *
 *   [N resultat] [filter pills…] [Rensa]        [Passar bäst ▾] [Bevaka] [view]
 *
 * The pills are the buyer's own filters only: the car and the product are in
 * the car bar above. The sort is a dropdown, the same one the phone has (it
 * was a row of five chips, P25009-445 BR-4).
 */
const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    viewToggleComponent,
    saveSearchComponent,
    isSortByActive,
    resultsCount,
    searchInProgress,
    noResultsInfo,
    pills,
    onRemovePill,
    onClearPills,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.toolbar}>
        <span className={css.resultsFound}>
          {searchInProgress ? (
            <FormattedMessage id="MainPanelHeader.loadingResults" />
          ) : (
            <>
              <strong className={css.resultsCount}>{resultsCount ?? 0}</strong> resultat
            </>
          )}
        </span>

        {pills?.length ? (
          <div className={css.pills}>
            <SelectedPills pills={pills} onRemove={onRemovePill} />
          </div>
        ) : null}
        {pills?.length && onClearPills ? (
          <button type="button" className={css.clearPills} onClick={onClearPills}>
            Rensa
          </button>
        ) : null}

        <div className={css.controls}>
          {isSortByActive && sortByComponent ? sortByComponent : null}
          {saveSearchComponent}
          {viewToggleComponent}
        </div>
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

MainPanelHeader.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  sortByComponent: null,
  saveSearchComponent: null,
  onClearPills: null,
};

MainPanelHeader.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  sortByComponent: node,
  saveSearchComponent: node,
  onClearPills: func,
};

export default MainPanelHeader;
